import {
    FETCH_BOOKING_LOCATION,
    FETCH_BOOKING_LOCATION_SUCCESS,
    FETCH_BOOKING_LOCATION_FAILED,
    STOP_LOCATION_FETCH,
    STORE_ADRESSES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { query, onValue, set, off, push, limitToLast } from "firebase/database";
import { signOutImmediate } from './authactions';

const AUTH_GRACE_MS = 4000;
let pendingAuthGraceTimer = null;
let pendingAuthGraceStartAt = 0;

export const saveTracking = (bookingId, location) => {
    const {
        trackingRef
    } = firebase;
    push(trackingRef(bookingId), location);
}

export const fetchBookingLocations = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: bookingId,
    });
    onValue(query(trackingRef(bookingId), limitToLast(1)),(snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const locations = Object.keys(data)
                .map((i) => {
                    return data[i]
                });
            if (locations.length == 1) {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_SUCCESS,
                    payload: locations[0]
                });
            }
            else {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
                });
            }
        } else {
            dispatch({
                type: FETCH_BOOKING_LOCATION_FAILED,
                payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
            });
        }
    });
};

export const stopLocationFetch = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: STOP_LOCATION_FETCH,
        payload: bookingId,
    });
    off(trackingRef(bookingId));
}

export const saveUserLocation = (location) => {
    const {
      auth,
      userLocationRef,
    } = firebase;
    const uid = auth && auth.currentUser ? auth.currentUser.uid : null;
    if (!uid) {
        // En mobile, `auth.currentUser` puede estar null transitoriamente (hidratación).
        // Esperamos una ventana corta y reintentamos; si persiste, forzamos volver a Login.
        const now = Date.now();
        if (!pendingAuthGraceTimer) {
            pendingAuthGraceStartAt = now;
        }

        if (pendingAuthGraceTimer) {
            // Ya hay un reintento programado; no duplicar timers.
            return;
        }

        pendingAuthGraceTimer = setTimeout(() => {
            pendingAuthGraceTimer = null;
            const currentUid = firebase?.auth?.currentUser?.uid;
            if (currentUid) {
                try {
                    set(firebase.userLocationRef(currentUid), location);
                } catch (_) {
                    // ignore
                }
                return;
            }

            if (Date.now() - pendingAuthGraceStartAt >= AUTH_GRACE_MS) {
                try {
                    store.dispatch(signOutImmediate());
                } catch (_) {
                    // ignore
                }
            }
        }, AUTH_GRACE_MS);

        return;
    }
    set(userLocationRef(uid), location);
}

export const storeAddresses = (data) => (dispatch) => {
    dispatch({
        type: STORE_ADRESSES,
        payload: data,
    });
}